import { GlassImpact } from './glass-impact';
import { LateralPrecisions } from './lateral-precisions';
import { LateralPosition, Light } from './lights';
export interface SinisterGlass {
  glass: Glass;
  glassExtended?: GlassExtended;
  impacts?: GlassImpact;
  lateralPrecisions?: LateralPrecisions;
  mirror?: LateralPosition;
  light?: Light;
}

export enum GlassEnum {
  windshield = 'windshield',
  rearWindow = 'rearWindow',
  lights = 'lights',
  mirror = 'mirror',
  topWindow = 'topWindow',
  sideWindow = 'sideWindow',
  multiple = 'multiple',
  other = 'other',
}

export type Glass = `${GlassEnum}`;

export enum GlassExtendedOnlyEnum {
  custodes = 'custodes',
}

export type GlassExtended = `${GlassEnum | GlassExtendedOnlyEnum}`;
